<template lang="pug">
  .orders
    el-row
      el-col(:span="16")
        el-form(:inline="true")
          el-form-item(label="微信号")
            el-select(
              v-model="orderByWX",
              remote,
              filterable,
              reserve-keyword,
              placeholder="请输入关键词",
              :remote-method="handleWXFilterSearch",
              :loading="wxFitlerLoading",
              @change="handleWXSelected"
            )
              el-option(
                v-for="item in wxOptions"
                :key="item._id"
                :label="item.userInfo.nickName"
                :value="item._id"
              )
                el-image.select-avatar(:src="item.userInfo.avatarUrl")
                span {{item.userInfo.nickName}}
          el-form-item(label="订单状态")
            el-select(v-model="pageModel.condition.status", placeholder="请选择订单状态", @change="query(1)")
              el-option(label="全部", value="all")
              el-option(
                v-for="(item, key) in $orderStatus",
                :key="key",
                :label="item",
                :value="key * 1"
              )
          el-form-item(label="收货人")
            el-col(:span="10")
              el-input(type="text", placeholder="请输入收货人姓名", v-model="pageModel.condition.expressname")
            el-col(:span="10")
              el-input(type="text", placeholder="请输入收货人电话", v-model="pageModel.condition.express_phone")
            el-col(:span="4")
              el-button(@click="query(1)") 查询
      el-col(:span="8")
        el-date-picker(
          v-model="exportDateTime"
          type="datetime"
          placeholder="选择日期时间"
        )
        el-button(type="warning", @click="handleExport") 导出实物订单
    el-table(:data="orders", stripe)
      el-table-column(prop="create_date", label="下单日期")
        template(slot-scope="scope")
          span {{$moment(scope.row.create_date).calendar()}}
      el-table-column(prop="good.name", label="商品")
      el-table-column(prop="user.userInfo.nickName", label="微信号")
      el-table-column(label="头像")
        template(slot-scope="scope")
          el-image.avatar(
            :src="scope.row.user.userInfo.avatarUrl",
            fit="cover",
            :preview-src-list="[scope.row.user.userInfo.avatarUrl]"
          )
      el-table-column(label="收货人", width="200")
        template(slot-scope="scope")
          div(v-if="scope.row.express && !scope.row.good.reward_tag")
            div 收货人：{{scope.row.express.name}}
            div 收货电话：{{scope.row.express.phone}}
            div(v-if="scope.row.express.address") 收货地址：{{scope.row.express.address}}
            div(v-else)
              div 所在地区：{{`${scope.row.express.province}${scope.row.express.city}${scope.row.express.area}`}}
              div 详细地址：{{scope.row.express.street}}
            div 订单备注：{{scope.row.desc || '-'}}
      el-table-column(label="快递信息")
        template(slot-scope="scope")
          span(v-if="scope.row.express")
            span(v-if="scope.row.express.company") [{{scope.row.express.company}}]
            | {{scope.row.express.num}}
      el-table-column(label="身份证信息")
        template(slot-scope="scope")
          div(v-if="scope.row.need_id")
            div 姓名：{{scope.row.id_name}}
            div 身份证号：{{scope.row.id_card}}
      el-table-column(label="订单状态")
        template(slot-scope="scope")
          el-tag(size="mini") {{$orderStatus[scope.row.status.toString()]}}
      el-table-column(label="操作")
        template(slot-scope="scope")
          el-button-group
            el-button(type="primary", size="mini", @click="handleExpressModify(scope.row)") 快递
            el-button(type="primary", size="mini", @click="handleStautsModify(scope.row)") 状态
            el-button(v-if="scope.row.express && !scope.row.express.shipment_msg_sended", type="warning", size="mini", @click="handleSendMsg(scope.row)") 发货通知
    el-pagination(
      background,
      :current-page="pageModel.pageNo",
      layout="prev, pager, next, total",
      :total="pageModel.total"
      @current-change="query"
    )
    OrderExpressForm(ref="expressForm", :orderId="modifyOrder._id", @saved="query")
    OrderStatusForm(ref="statusForm", :orderId="modifyOrder._id", @saved="query")
</template>

<script>
import OrderExpressForm from '../../components/order/express.form.vue'
import OrderStatusForm from '../../components/order/status.form.vue'

import ExportJsonExcel from 'js-export-excel'

export default {
  components: {
    OrderExpressForm,
    OrderStatusForm
  },
  data() {
    return {
      orders: [],
      modifyOrder: {},
      exportDateTime: this.$moment().add(-1, 'days'),
      pageModel: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        condition: {
          user: null,
          status: 'all',
          expressname: null,
          express_phone: null
        }
      },
      userPageModel: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      orderByWX: null,
      wxFitlerLoading: false,
      wxOptions: []
    }
  },
  mounted() {
    this.query(1)
  },
  methods: {
    query(pageNo) {
      let _condition = {}
      if (this.pageModel.condition.user) {
        _condition.user = this.pageModel.condition.user
      }
      if (this.pageModel.condition.status !== 'all') {
        _condition.status = this.pageModel.condition.status
      }
      if (this.pageModel.condition.expressname) {
        _condition.expressname = this.pageModel.condition.expressname
      }
      if (this.pageModel.condition.express_phone) {
        _condition.express_phone = this.pageModel.condition.express_phone
      }
      this.pageModel.pageNo = pageNo || this.pageModel.pageNo
      this.$service.OrderService
        .query({
          pageNo: this.pageModel.pageNo,
          pageSize: this.pageModel.pageSize,
          condition: _condition
        })
        .then(res => {
          if (res.status === 200) {
            this.pageModel.total = res.data.data.total
            res.data.data.orders.forEach((item) => {
              item.user.userInfo = item.user.userInfo || {}
            })
            this.orders = res.data.data.orders
          }
        })
    },
    handleExpressModify(order) {
      this.modifyOrder = order
      this.$refs.expressForm.show()
    },
    handleStautsModify(order) {
      this.modifyOrder = order
      this.$refs.statusForm.show()
    },
    handleSendMsg(order) {
      if (!order.express) {
        this.$message({
          message: '没有物流信息无法推送消息',
          type: 'warning'
        });
      } else if (order.express.shipment_msg_sended) {
        this.$message({
          message: '发货信息已推送过',
          type: 'warning'
        });
      } else {
        let _id = 'zAmfZ0hDphmTkhqxKzhwxjVRFzJ7_qGH02_kf8kzQMg'
        if(order.good.is_reward) {
          _id = 'FmPydPvEVb2BMPP37KyxQkLoNZJmHadBPQi_Fjz68Vg'
        }
        this.$service.OrderService
          .sendMsg(order._id, _id)
          .then(res => {
            this.query();
            if (res.status === 201 && res.data.code === 0) {
              this.$message({
                message: '消息已发送',
                type: 'success'
              });
            }
          })
          .catch(err => {
            this.query();
            this.$message({
                message: err.message,
                type: 'error'
              });
          })
      }
    },
    handleWXFilterSearch(val) {
      if (val) {
        this.userPageModel.condition = {
          'userInfo.nickName': val
        }
      } else {
        this.userPageModel.condition = null
      }
      this.wxFitlerLoading = true
      this.$service.UserService
        .query(this.userPageModel)
        .then(res => {
          this.wxFitlerLoading = false
          if (res.status === 200 && res.data.code === 0) {
            this.userPageModel.total = res.data.data.total
            this.wxOptions = res.data.data.users
          }
        })
        .catch(() => {
          this.wxFitlerLoading = false
        })
    },
    handleWXSelected(val) {
      this.pageModel.condition.user = val
      this.query(1)
    },
    handleExport() {
      this.$service.OrderService
        .exportsData({
          pageNo: 1,
          pageSize: 9999,
          condition: {
            express_exists: true,
            gt_create_date: this.exportDateTime
          }
        })
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            let _opt = {
              filename: `orders.${Date.now()}.xlsx`
            }

            let _excelData = []

            res.data.data.orders.forEach((item) => {
              if (item.express.address) {
                let _str = item.express.address
                let _tmp = _str.split('省')
                let _infos = []
                if (_tmp.length === 2) {
                  _infos.push(_tmp[0])
                  _str = _tmp[1]
                } else {
                  _infos.push('')
                }
                _tmp = _str.split('市')
                if (_tmp.length === 2) {
                  _infos.push(_tmp[0])
                  _str = _tmp[1]
                } else {
                  _infos.push('')
                }
                _infos.push(_str)
                _excelData.push([this.$moment(item.create_date).format('YYYY-MM-DD HH:mm:ss'), item.express.name, item.express.phone, ..._infos])
              }
            })

            _opt.datas = [
              {
                sheetData: _excelData,
                sheetName: 'sheet',
                sheetHeader:['创建日期','收货人', '联系电话', '省', '市', '区', '详细地址']
              }
            ]

            let toExcel = new ExportJsonExcel(_opt); 
            toExcel.saveExcel();
          }
        })
    }
  },
}
</script>

<style lang="less" scope>
</style>